{
  "label_empty": "Нет данных",
  "label-actions": "Действия",
  "label-row-select": "Выбрать"
}
